import { render, staticRenderFns } from "./VirtualStock.vue?vue&type=template&id=78171b56&scoped=true&"
import script from "./VirtualStock.vue?vue&type=script&lang=js&"
export * from "./VirtualStock.vue?vue&type=script&lang=js&"
import style0 from "./VirtualStock.vue?vue&type=style&index=0&id=78171b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78171b56",
  null
  
)

export default component.exports